@let cfg = config();

<div #toolbar [ngClass]="{
		'toolbar-widget': true,
		'toolbar-is-scrollable':isScrollable(),
	}">

	<div class='toolbar-content' [style.background-color]="cfg.backgroundColor">
		<ng-content></ng-content>
	</div>

	<div class='toolbar-icon' [style.color]="cfg.iconColor">
		<i class='fa-fw fa-regular {{cfg.icon}}' [title]='cfg.title'></i>
	</div>

</div>